// Tabbed content
function initTabs(container) {
	const tabLinks = [...container.querySelectorAll('.which-areas__tab-buttons')]
	const tabContents = [...container.querySelectorAll('.which-areas__content')]

    tabLinks.map(link => link.addEventListener('click', clickHandler))

    function clickHandler(event) {
		event.preventDefault()
		const tab = event.currentTarget
		const tabId = tab.getAttribute('data-tab')

		tabLinks.map(el => {
			el.classList.remove('active')
		})

		tabContents.map(el => el.classList.remove('active') )

		tab.classList.add('active')
		container.querySelector(`#${tabId}`)?.classList.add('active')
	}

}

[...document.querySelectorAll('#which-areas')].map(initTabs)



// Hide / show areas
const showButtons = document.querySelectorAll('.which-areas__button.show--areas')
const hideButtons = document.querySelectorAll('.which-areas__button.hide--areas')

function showAreas() {
    var parentItem = this.parentElement
    var hideButton = parentItem.querySelector('.hide--areas')

    this.classList.remove('show--button')
    parentItem.classList.add('show-all')
    hideButton.classList.add('show--button')
}

function hideAreas() {
    var parentItem = this.parentElement
    var showButton = parentItem.querySelector('.show--areas')

    this.classList.remove('show--button')
    parentItem.classList.remove('show-all')
    showButton.classList.add('show--button')
}

if (showButtons) {
	showButtons.forEach(function(el) {
		el.addEventListener('click', showAreas);
	});
}

if (hideButtons) {
	hideButtons.forEach(function(el) {
		el.addEventListener('click', hideAreas);
	});
}